export default "__VITE_ASSET__9b60cb03__"